import { ConfigSchemaV1Type } from '@/providers/ConfigProvider/ConfigSchemaV1Type';
import { ConfigV1Type } from '@/providers/ConfigProvider/ConfigV1Type';
import { NetworkApiError, NoActiveRequestsApiError } from '@/utils/errors';

const INTERNAL_OPERATIONS_URL_BASE =
  '/internal-operations/contactless-identity-verification';

const CLIENT_CONFIG_URL_BASE = '/client-config';

export type ValidationResponseType = {
  validationResult: 'Success' | 'Failure' | 'Retry';
};

const headers = {
  Accept: 'application/json;v=1',
  'AirKey-Version': '2',
  'Content-Type': 'application/json',
};

export async function getSession(
  intentOwner: string,
  workflow: string,
  sessionId: string,
) {
  const response = await fetch(
    `${INTERNAL_OPERATIONS_URL_BASE}/intent-owners/${intentOwner}/workflows/${workflow}/sessions/${sessionId}`,
    {
      method: 'GET',
      headers,
    },
  );

  if (response.status === 404) {
    throw new NoActiveRequestsApiError();
  }
  if (!response.ok) {
    throw new Error(
      `Failed to fetch session for sessionId ${sessionId} with status ${response.status}`,
    );
  }

  return response.json();
}

export async function validateTap(
  sessionId: string,
  message: string,
  intentOwner: string,
  workflow: string,
): Promise<ValidationResponseType> {
  const url = `${INTERNAL_OPERATIONS_URL_BASE}/validation/session-tokens/validate-message`;

  const options: RequestInit = {
    method: 'POST',
    headers,
    body: JSON.stringify({ message, intentOwner, workflow, sessionId }),
  };

  const response = await fetch(url, options);

  if (response.status === 404) {
    throw new NoActiveRequestsApiError();
  }

  if (!response.ok) {
    throw new NetworkApiError(
      `Network response was not ok: ${response.statusText}`,
    );
  }

  return response.json();
}

export async function rejectTx(
  sessionId: string,
  intentOwner: string,
  workflow: string,
): Promise<boolean> {
  const url = `${INTERNAL_OPERATIONS_URL_BASE}/submit-user-event`;

  const options: RequestInit = {
    method: 'POST',
    headers,
    body: JSON.stringify({
      sessionId,
      intentOwner,
      workflow,
      eventName: 'INVALIDATED',
      eventData: [],
      userData: [],
    }),
  };

  const response = await fetch(url, options);

  if (response.status === 404) {
    throw new NoActiveRequestsApiError();
  }

  return response.ok;
}

/******************************
 * 					Configs						*
 ******************************/

export async function getConfig(
  intentOwner: string,
  workflow: string,
): Promise<ConfigV1Type> {
  const response = await fetch(
    `${CLIENT_CONFIG_URL_BASE}/${intentOwner}/${workflow}/config-v1.json`,
    {
      method: 'GET',
      headers,
    },
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch config 
			for intentOwner: ${intentOwner}, workflow: ${workflow}. 
			Status: ${response.status}`,
    );
  }

  return response.json();
}
export async function getConfigSchema(): Promise<ConfigSchemaV1Type> {
  const response = await fetch(
    `${CLIENT_CONFIG_URL_BASE}/airkey-config-schema/configSchema-v1.json`,
    {
      method: 'GET',
      headers,
    },
  );

  if (!response.ok) {
    throw new Error('Failed to fetch config schema');
  }

  return response.json();
}
